/**
 * API da tela /pg (cobranca da licenca). Nao ha sessao: a senha vai no header
 * `x-pg-senha` em toda chamada, e mora so na memoria do componente.
 *
 * A API responde 404 (nao 401/403) para senha errada, de proposito: nao
 * confirma que a rota existe. Trate `status === 404` como "senha invalida" e
 * `429` como "muitas tentativas".
 */

import axios from "@/utils/axios";

const cfg = (senha) => ({ headers: { "x-pg-senha": senha } });

const login = async (senha) => (await axios.post("/pg/login", { senha })).data;

const getConfig = async (senha) => (await axios.get("/pg/config", cfg(senha))).data;

const storeConfig = async (senha, dados) =>
  (await axios.post("/pg/config", dados, cfg(senha))).data;

const pagar = async (senha, dados) =>
  (await axios.post("/pg/pagamentos", dados, cfg(senha))).data;

const desfazerPagamento = async (senha, competencia) =>
  (await axios.post("/pg/pagamentos/del", { competencia }, cfg(senha))).data;

export default { login, getConfig, storeConfig, pagar, desfazerPagamento };
